import UsuarioEntity from "./UsuarioEntity";

export default class ConfirmacaoEmailEntity {
    constructor(public id?: number, public usuario?: UsuarioEntity, public codigo?: string) {}
}
